module.exports = __webpack_public_path__ + "img/200.e94b9a03.jpg";